export class LeelooTracker
{
    productView()
    {
        /* leeloo init code */
        window.LEELOO = function(){
            window.LEELOO_INIT = { id: '5d654e008818cc001113202a' };
            var js = document.createElement('script');
            js.src = 'https://app.leeloo.ai/init.js';
            js.async = true;
            document.getElementsByTagName('head')[0].appendChild(js);
        }; LEELOO();
        /* end leeloo init code */
    }
    orderThankyouPageView()
    {
        /* leeloo init code */
        window.LEELOO = function(){
            window.LEELOO_INIT = { id: '5d654e008818cc001113202a' };
            var js = document.createElement('script');
            js.src = 'https://app.leeloo.ai/init.js';
            js.async = true;
            document.getElementsByTagName('head')[0].appendChild(js);
        }; LEELOO();
        /* end leeloo init code */
    }
    landingView()
    {
        /* leeloo init code */
        window.LEELOO = function(){
            window.LEELOO_INIT = { id: '5d654e008818cc001113202a' };
            var js = document.createElement('script');
            js.src = 'https://app.leeloo.ai/init.js';
            js.async = true;
            document.getElementsByTagName('head')[0].appendChild(js);
        }; LEELOO();
        /* end leeloo init code */
    }
}


// WEBPACK FOOTER //
// ./modules/tracker/leeloo.js